import styled, { css } from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { FONT_BASE_COLOR, CLICKABLE_COLOR } from '@CSSVars/colors'


export const _RecipientInput = styled.div`
  position: relative;
  > div {
    margin-bottom: 0;
  }
  input[disabled] {
    color: black;
    background: none;
  }
`

const iconContainerShareCss = css`
  right: 10px;
  top: 25px;
  transform: translateY(-50%);

`

export const _CloseContainer = styled.div`
  ${iconContainerShareCss};
  position: absolute;
  &:hover {
    cursor: pointer;
  }
  svg {
    fill: ${FONT_BASE_COLOR};
  }

`

export const _AddBtn = styled.div`
  ${iconContainerShareCss};
  position: absolute;
  color: ${CLICKABLE_COLOR};
  &:hover {
    cursor: pointer;
  }
`
